import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import { SearchBackDrop } from "../component/common/SearchBackDrop";
import TzaWorkerPRCPage from "./prc/TzaWorkerPRCPage";
import TzaWorkerTransPage from "./trans/TzaWorkerTransPage";
import TzaWorkerISPPage from "./isp/TzaWorkerISPPage";
import EvalWorkerPage from "./EvalWorkerPage";
import TzaWorkerWikiPage from "./wiki/TzaWorkerWikiPage";
import EvknSimpleQAPage from "./create/EvknSimpleQAPage";
import EvknHellaSwagPage from "./create/EvknHellaSwagPage";
import EvknMMLUPage from "./create/EvknMMLUPage";
import EvknCreatePage from "./create/EvknSimpleQAPage";
import EvltCreatePage from "./evlt/EvltCreatePage";
import NarrativeQAPage from "./evlt/NarrativeQAPage";
import LFSumPage from "./evlt/LFSumPage";
import EvknOpenBookPage from "./create/EvknOpenBookPage"
import EvltInsertSentencePage from "./evlt/EvltInsertSentencePage";
import EvltIdkPage from "./evlt/EvltIdkPage";
import LogiQAPage from "./evlt/LogiQAPage";
import MRCRQAPage from "./evlt/MRCRQAPage";
import EvknCategory from "./create/EvknCategory";
import EvknRSimpleQAPage from "./create/EvknRSimpleQAPage";
import EvknRMMLUQAPage from "./create/EvknRMMLUQAPage";
import BufsWorkerPage from "./evlt/BufsWorkerPage";
import EvknRHellaSwagPage from "./create/EvknRHellaSwagQAPage";


const EvalWorkerRouter = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  return (
    <Box>
      <Routes>
        <Route path="/evkn-category" element={<EvknCategory />} /> 
        <Route path="/rsimpleqa" element={<EvknRSimpleQAPage />} /> 
        <Route path="/rhellaswag" element={<EvknRHellaSwagPage />} /> 
        <Route path="/rmmlu" element={<EvknRMMLUQAPage />} /> 
        <Route path="/simple" element={<EvknSimpleQAPage />} /> 
        <Route path="/prc-openbook" element={<EvknOpenBookPage />} /> 
        <Route path="/hellaswag" element={<EvknHellaSwagPage />} /> 
        <Route path="/mmlu" element={<EvknMMLUPage />} /> 
        
        <Route path="/bufsPage" element={<BufsWorkerPage />} />
        <Route path="/create-context" element={<EvltCreatePage />} /> 
        <Route path="/narrativeqa" element={<NarrativeQAPage />} /> 
        <Route path="/lfsum" element={<LFSumPage />} /> 
        <Route path="/mrcr" element={<MRCRQAPage />} /> 
        <Route path="/logiqa" element={<LogiQAPage />} /> 
        <Route path="/insertSentence" element={<EvltInsertSentencePage />} />
        <Route path="/idk" element={<EvltIdkPage />} />
        <Route path="/prc" element={<TzaWorkerPRCPage />} />
        <Route path="/isp" element={<TzaWorkerISPPage />} />
        <Route path="*" element={<EvalWorkerPage />} />
      </Routes>
    </Box>
  );
};

export default EvalWorkerRouter;
